export default __webpack_public_path__ + "static/media/close.66c28cbf.svg";